// extracted by mini-css-extract-plugin
export var carrierTab = "_5c-0";
export var carrierTabActive = "_5c-1 _5c-0";
export var carrierTabInactive = "_5c-2 _5c-0";
export var carrierTabLabel = "_5c-3";
export var carrierTabLabelActive = "_5c-4 _5c-3";
export var carrierTabLabelInactive = "_5c-5 _5c-3";
export var carrierTabPercentage = "_5c-6";
export var carrierTabPercentageActive = "_5c-7 _5c-6";
export var carrierTabPercentageInactive = "_5c-8 _5c-6";
export var carrierTabWinnable = "_5c-9";
export var carrierTabWinnableActive = "_5c-a _5c-9";
export var carrierTabWinnableInactive = "_5c-b _5c-9";
export var comparisonContainer = "_5c-d";
export var missingRateButton = "_5c-n";
export var missingRateButtonActive = "_5c-o _5c-n";
export var missingRateButtonInactive = "_5c-p _5c-n";
export var missingRateButtonLabel = "_5c-q";
export var missingRateButtonLabelActive = "_5c-r _5c-q";
export var missingRateButtonLabelInactive = "_5c-s _5c-q";
export var sidebar = "_5c-c";
export var strategyButton = "_5c-e";
export var strategyButtonActive = "_5c-f _5c-e";
export var strategyButtonDescription = "_5c-k";
export var strategyButtonDescriptionActive = "_5c-l _5c-k";
export var strategyButtonDescriptionInactive = "_5c-m _5c-k";
export var strategyButtonInactive = "_5c-g _5c-e";
export var strategyButtonLabel = "_5c-h";
export var strategyButtonLabelActive = "_5c-i _5c-h";
export var strategyButtonLabelInactive = "_5c-j _5c-h";
export var unitToggleButton = "_5c-t";
export var unitToggleButtonActive = "_5c-u _5c-t";
export var unitToggleButtonInactive = "_5c-v _5c-t";
export var unitToggleButtonLabel = "_5c-w";
export var unitToggleButtonLabelActive = "_5c-x _5c-w";
export var unitToggleButtonLabelInactive = "_5c-y _5c-w";